/* global _pafw_payment_blocks */

import { _ } from 'underscore';
import { useEffect } from 'react';
import { decodeEntities } from '@wordpress/html-entities';

function versionCompare( a, b ) {
    var va = a.split( '.' ),
        vb = b.split( '.' );

    for ( var i = 0; i < 3; i++ ) {
        if ( parseInt( va[i] ) > parseInt( vb[i] ) ) {
            return 1;
        } else if ( parseInt( va[i] ) < parseInt( vb[i] ) ) {
            return -1;
        }
    }

    return 0;
}

export const pafwProcessPayment = ( props, obj ) => {
    const { emitResponse, settings } = props;
    const { uuid: paymentFormID } = settings;

    let prefix = 'iamport_',
        paymentDetails = obj.processingResponse.paymentDetails,
        iamport = JSON.parse( paymentDetails.iamport_json ),
        payMethod = props.activePaymentMethod.substring( prefix.length );

    let reqParam = {
        pg: iamport.pg,
        pay_method: iamport.pay_method || payMethod,
        escrow: iamport.escrow,
        merchant_uid: iamport.merchant_uid,
        name: iamport.name,
        amount: parseFloat( iamport.amount ),
        buyer_email: iamport.buyer_email,
        buyer_name: iamport.buyer_name,
        buyer_tel: iamport.buyer_tel,
        buyer_addr: iamport.buyer_addr,
        buyer_postcode: iamport.buyer_postcode,
        vbank_due: iamport.vbank_due,
        m_redirect_url: iamport.m_redirect_url,
        currency: iamport.currency,
        digital: iamport.digital || false,
        custom_data: {
            woocommerce: paymentDetails.order_id,
            devops: "codemshop"
        },
        biz_num: iamport.biz_num,
        niceMobileV2: true
    };

    if ( typeof iamport.tax_free == "number" ) reqParam.tax_free = iamport.tax_free;
    if ( iamport.language ) reqParam.language = iamport.language;
    if ( iamport.customer_uid ) reqParam.customer_uid = iamport.customer_uid;
    if ( iamport.kcpProducts ) reqParam.kcpProducts = iamport.kcpProducts;
    if ( iamport.naverPopupMode ) reqParam.naverPopupMode = true;
    if ( iamport.naverProducts ) reqParam.naverProducts = iamport.naverProducts;
    if ( iamport.naverUseCfm ) reqParam.naverUseCfm = iamport.naverUseCfm;
    if ( iamport.notice_url ) reqParam.notice_url = iamport.notice_url;
    if ( iamport.period ) reqParam.period = iamport.period;

    if ( iamport.card_quota ) {
        reqParam.display = { card_quota: iamport.card_quota };
    }

    if ( versionCompare( $.fn.jquery, "1.8.0" ) >= 0 ) {
        if ( typeof window.$ == 'undefined' ) window.$ = $;
        reqParam.kakaoOpenApp = true;
    }

    if ( 'iamport_foreign_card' === iamport.pg ) {
        reqParam.bypass = {
            tosspayments: {
                useInternationalCardOnly: true, // 영어 결제창 활성화
            },
        }
    }

    //[2020-09-25] eximbay 결제수단 지정
    if ( iamport.pg === 'eximbay' ) {
        var eximbay_pay_method = $( '#iamport_eximbay-pay-method' ).val();
        reqParam.pay_method = eximbay_pay_method;
        if ( eximbay_pay_method === 'econtext' && reqParam.currency !== 'JPY' ) {
            // [2020-06-18] 엑심베이 - 일본 편의점 결제는 무조건 currency가 JPY만 허용됨
            alert( '엑심베이 일본 편의점 결제는 엔화(¥)만 허용됩니다. 통화를 변경하고 다시 시도해주세요' );
            window.location.reload();
            return;
        }
    }

    IMP.init( iamport.user_code );

    IMP.request_pay( reqParam, function ( rsp ) {
        if ( rsp.success === true || rsp.error_msg === null ) {
            window.location.href = iamport.m_redirect_url + "&imp_uid=" + rsp.imp_uid;
        } else {
            alert( rsp.error_msg );
            window.location.reload();
        }
    } );

    return new Promise( () => {
    } );
}

export const PafwContent = ( props ) => {
    const { eventRegistration, emitResponse, settings } = props;
    const { onCheckoutSuccess } = eventRegistration;
    const { uuid: paymentFormID } = settings;

    useEffect( () => {
        const checkoutSuccess = onCheckoutSuccess( async ( obj ) => {
            return pafwProcessPayment( props, obj );
        } );
        return () => {
            checkoutSuccess()
        };
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        onCheckoutSuccess
    ] );

    return decodeEntities( props.settings.description || '' );
};

/**
 * Label component
 *
 * @param {*} props Props from payment API.
 */
export const PafwLabel = ( props ) => {
    const { PaymentMethodLabel } = props.components;
    return <PaymentMethodLabel text={ props.settings.title }/>;
};